module.exports = __webpack_public_path__ + "media/images/landing_pages/sport_travel-492ef4e22cd8f4e13e3e73f6bcf15e07.svg";